import { render } from "./HostedInstanceEditorWrapper.vue?vue&type=template&id=1cfbffa8"
import script from "./HostedInstanceEditorWrapper.vue?vue&type=script&lang=js"
export * from "./HostedInstanceEditorWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__